import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';



export interface ProductModule {
  id: number;
  moduleName: string;
  moduleNumber: string;
  description: string;
  productCategory: string;
  productItem: string;
  productType: string;
  productId: number;
  parent: ProductModule;
  partNumber : number;
  children: ProductModule[];
}

export interface ProductModuleRequest {
  id : number;
  moduleName: string;
  moduleNumber: string;
  description: string;
  productId: number;
  parentId: number;
}

export interface ProductModuleParents {
  id: number;
  moduleName: string;
  moduleNumber: string;
  description: string;
  productCategory: string;
  productItem: string;
  productType: string;
  productId: number;
  parent: ProductModule;
  partNumber : number;
}


@Injectable({
  providedIn: 'root'
})
export class ProductTrackService {

  private PATH = "/appliances/api/v2/productModule/"; 

  constructor(private http: HttpClient) {
    
  }

  getProductMosules(): Observable<ProductModule[]> {
     const token = localStorage.getItem("token");
      const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<ProductModule[]>(this.PATH , { headers });
  }

  getProductModulesById(id: number): Observable<ProductModule> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<ProductModule>(this.PATH + id , { headers });
  }

  CreateProductModule(productModule: ProductModuleRequest): Observable<ProductModule> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any>(this.PATH, productModule , { headers });
  }

  UpdateProductModule(productModule: ProductModuleRequest): Observable<ProductModule> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.put<any>(this.PATH, productModule , { headers });
  }

  getProductModukesParent(): Observable<ProductModuleParents[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<ProductModule[]>(this.PATH +'parents' , { headers });
  }
 
}
